import Vue from 'vue';
import Vuex from 'vuex';
import router, {
  constantRoutes,
  asyncRoutes,
  asyncRoutes4Member,
  asyncRoutes4VipMember,
  asyncRoutes4Manager,
  asyncRoutes4Creator,
  publicRoutes,
  asyncRouteNameList,
  asyncRoute4MemberNameList,
  asyncRoute4VipMemberNameList,
  asyncRoute4ManagerNameList,
  asyncRoute4VipManagerNameList,
  asyncRoutes4VipManager,
  asyncRoute4CreatorNameList,
  resetRouter,
  asyncCloudRoutes,
  asyncCloudRoutesNameList,
  asyncActConfRoutes,
  asyncActConfRoutesNameList,
} from '@/router';
import { getKfzInfo } from '@/api/common';
import { getStudioDetail } from '@/api/studio';
import { parseUserInfoFromCookie } from '../utils';
import { parseAccountSecurityFromDeveloperInfo } from '../utils/accountSecurity';

Vue.use(Vuex);
let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
if (!userInfo.uin) {
  userInfo = parseUserInfoFromCookie() || {};
  if (userInfo.uin) {
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
  }
}
export default new Vuex.Store({
  state: {
    downloadBle: 0,
    routes: constantRoutes(),
    userInfo: userInfo,
    bankInfo: JSON.parse(sessionStorage.getItem('bankInfo') || '{}'),
    developerInfo: JSON.parse(sessionStorage.getItem('developerInfo') || '{}'),
    studioBaseInfo: JSON.parse(
      sessionStorage.getItem('studioBaseInfo') || '{}',
    ),
    backLabel: JSON.parse(sessionStorage.getItem('backLabel') || '{}'),
    //userTxt:JSON.parse(sessionStorage.getItem(userTxt))
  },
  mutations: {
    SET_DOWNLOADBLE(state, val) {
      state.downloadBle = val;
      sessionStorage.setItem('downloadBle', val);
    },
    SET_BACKLABEL(state, data) {
      state.backLabel = data;
      sessionStorage.setItem('backLabel', data);
    },
    SET_USER_INFO(state, data) {
      state.userInfo = data;
      sessionStorage.setItem('userInfo', JSON.stringify(data));
    },
    CLEAR_ALL_INFO(state) {
      state.userInfo = {};
      sessionStorage.removeItem('userInfo');
      state.bankInfo = {};
      sessionStorage.removeItem('bankInfo');
      state.developerInfo = {};
      sessionStorage.removeItem('developerInfo');
      state.studioBaseInfo = {};
      sessionStorage.removeItem('studioBaseInfo');
      sessionStorage.removeItem('account_security_verified');
    },
    RESET_ROUTER(state) {
      resetRouter();
      state.routes = constantRoutes();
    },
    SET_BANK_INFO(state, data) {
      state.bankInfo = data;
      sessionStorage.setItem('bankInfo', JSON.stringify(data));
    },
    SET_DEVELOPER_INFO(state, data) {
      state.developerInfo = data || {};
      sessionStorage.setItem(
        'developerInfo',
        JSON.stringify(state.developerInfo),
      );
    },
    /** 更新账户安全开关，同步写入 developerInfo.phone_auth / sec_pw */
    SET_ACCOUNT_SECURITY(state, payload) {
      const info = { ...state.developerInfo };
      if (Object.prototype.hasOwnProperty.call(payload, 'smsOn')) {
        info.phone_auth = payload.smsOn ? 1 : 0;
      }
      if (Object.prototype.hasOwnProperty.call(payload, 'independentPwdOn')) {
        info.sec_pw = payload.independentPwdOn ? 1 : 0;
      }
      state.developerInfo = info;
      sessionStorage.setItem(
        'developerInfo',
        JSON.stringify(state.developerInfo),
      );
    },
    SET_STUDIO_BASE_INFO(state, data) {
      state.studioBaseInfo = data;
      sessionStorage.setItem('studioBaseInfo', JSON.stringify(data));
    },
    // 添加动态路由
    ADD_ASYNC_ROUTES(state) {
      const hasAdded = !!state.routes.find(route =>
        asyncRouteNameList.includes(route.name),
      );

      if (hasAdded) return;

      let newRoutes = [...state.routes];
      // 添加动态路由
      asyncRoutes.forEach(route => router.addRoute(route));

      // 更新 state
      newRoutes.splice(1, 0, ...asyncRoutes);
      state.routes = newRoutes;
    },
    ADD_ASYNC_ROUTES_FOR_CLOUD(state) {
      const hasAdded = !!state.routes.find(route =>
        asyncCloudRoutesNameList.includes(route.name),
      );

      if (hasAdded) return;

      asyncCloudRoutes.forEach(route => router.addRoute(route));

      let accountIndex = -1;
      for (let i = 0; i < state.routes.length; i++) {
        if (state.routes[i].name === 'Account') {
          accountIndex = i;
        }
      }

      if (accountIndex >= 0) {
        state.routes.splice(accountIndex, 0, ...asyncCloudRoutes);
      } else {
        let newRoutes = [...state.routes, ...asyncCloudRoutes];
        state.routes = newRoutes;
      }
    },
    ADD_ACT_CONF_ROUTES(state) {
      const hasAdded = !!state.routes.find(route =>
        asyncActConfRoutesNameList.includes(route.name),
      );

      if (hasAdded) return;
      asyncActConfRoutes.forEach(route => router.addRoute(route));

      let accountIndex = -1;
      for (let i = 0; i < state.routes.length; i++) {
        if (state.routes[i].name === 'Account') {
          accountIndex = i;
        }
      }

      if (accountIndex >= 0) {
        state.routes.splice(accountIndex, 0, ...asyncActConfRoutes);
      } else {
        let newRoutes = [...state.routes, ...asyncActConfRoutes];
        state.routes = newRoutes;
      }
    },
    ADD_ASYNC_ROUTES_FOR_ROLE(state, role) {
      let asyncRouteNameList, asyncRoutes;
      if (role == 'vip_manager') {
        asyncRouteNameList = asyncRoute4VipManagerNameList;
        asyncRoutes = asyncRoutes4VipManager;
      } else if (role === 'manager') {
        asyncRouteNameList = asyncRoute4ManagerNameList;
        asyncRoutes = asyncRoutes4Manager;
      } else if (role === 'vipMember') {
        asyncRouteNameList = asyncRoute4VipMemberNameList;
        asyncRoutes = asyncRoutes4VipMember;
      } else if (role === 'member') {
        asyncRouteNameList = asyncRoute4MemberNameList;
        asyncRoutes = asyncRoutes4Member;
      } else if (role === 'studioCreator') {
        asyncRouteNameList = asyncRoute4CreatorNameList;
        asyncRoutes = asyncRoutes4Creator;
      }
      const hasAdded = !!state.routes.find(route =>
        asyncRouteNameList[0].startsWith(route.name),
      );
      if (hasAdded) return;
      asyncRoutes.forEach(route => router.addRoute(route));

      let accountIndex = -1;
      for (let i = 0; i < state.routes.length; i++) {
        if (state.routes[i].name === 'Activity') {
          // 工作室插到激励计划前面
          accountIndex = i;
        }
        if (role.startsWith('vip') && state.routes[i].name === 'Income') {
          let EShopIndex = -1;
          for (let j = 0; j < state.routes[i].children.length; j++) {
            if (~state.routes[i].children[j].path.indexOf('/exchangeShop')) {
              EShopIndex = j;
            }
          }
          if (EShopIndex > -1) {
            state.routes[i].children.splice(EShopIndex, 1);
          }
        }
      }

      if (accountIndex >= 0) {
        console.log(...asyncRoutes);
        state.routes.splice(accountIndex, 0, ...asyncRoutes);
        console.log(state.routes);
      } else {
        let newRoutes = [...state.routes, ...asyncRoutes];
        state.routes = newRoutes;
      }
    },
  },
  getters: {
    /** 由 getKfzInfo 的 phone_auth、sec_pw 派生 */
    accountSecurity(state) {
      return parseAccountSecurityFromDeveloperInfo(state.developerInfo);
    },
  },
  actions: {
    async addAsyncRoutes({ state, commit }) {
      const [studioRes, kfzRes] = await Promise.allSettled([
        getStudioDetail({ json: 1 }),
        getKfzInfo(),
      ]);

      const studioBaseInfo =
        studioRes.status === 'fulfilled' ? studioRes.value.data : null;
      const developerInfo =
        kfzRes.status === 'fulfilled' ? kfzRes.value.data : {};

      if (studioRes.status === 'rejected') {
        console.warn('[store] studio_query_detail 失败，跳过工作室路由', studioRes.reason);
      }
      if (kfzRes.status === 'rejected') {
        console.warn('[store] getKfzInfo 失败，使用空 developerInfo', kfzRes.reason);
      }
      // 收益管理相关路由
      // if (developerInfo.state === 1) {
      //   commit('ADD_ASYNC_ROUTES');
      // }
      const isCanuseeAct = localStorage.getItem(
        'act_canusee' + state.userInfo.uin,
      );
      console.log('act_canusee' + state.userInfo.uin, isCanuseeAct);
      if (isCanuseeAct == 1) {
        commit('ADD_ACT_CONF_ROUTES');
      }
      // 云服相关路由
      const apiid = parseInt(state.userInfo.apiid || 0, 10);
      const apiids = (
        window.apiidWhitelist[
          ~location.href.indexOf('-test') ? 'test' : 'prod'
        ] || []
      ).map(id => parseInt(id, 10));
      if (
        typeof state.userInfo.apiid === 'undefined' ||
        !apiids.length ||
        apiids.includes(apiid)
      ) {
        commit('ADD_ASYNC_ROUTES_FOR_CLOUD');
      }

      // 工作室相关路由
      if (studioBaseInfo) {
        if (
          developerInfo.studio_position === 1 &&
          developerInfo.member_vip === 1
        ) {
          commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'vip_manager');
        } else if (developerInfo.studio_position === 1) {
          commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'manager');
        } else if (developerInfo.member_vip === 1) {
          commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'vipMember');
        } else {
          commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'member');
        }
      } else {
        commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'studioCreator');
      }
      // 添加公共路由，如 404
      router.addRoute(...publicRoutes);

      // 存储缓存
      commit('SET_DEVELOPER_INFO', developerInfo);
      if (studioBaseInfo) {
        commit('SET_STUDIO_BASE_INFO', studioBaseInfo);
      }
    },
  },
  modules: {},
});
